<isophi-app-portfolio-plan-base-item #base *transloco="let t" [leftIcon]="'school'" [title]="t('planDetail/competence')"
                              [allowEditMode]="allowEditMode">
  <ng-container *ngIf="tags$ | async as tags; else loading">
    <ng-container *ngIf="isCompact(tags); else legacyLayout">
      <ng-container *ngIf="groups$ | async as groups">
        <div class="competence-groups" *ngIf="base.isViewMode()">
          <ng-container *ngFor="let group of groups">
            <div class="competence-group" *ngIf="hasSelected(group)">
              <span class="categories-title" *ngIf="group.area">{{ group.area.shortName || group.area.name }}</span>
              <ng-container *ngFor="let row of group.rows; trackBy: trackRow">
                <div class="competence-row" *ngIf="isSelected(row.tag.uuid)" [style.background]="rowBackground(row)">
                  <span class="competence-number" *ngIf="row.number">{{ row.number }}</span>
                  <span>{{ row.tag.name }}</span>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>

        <div class="competence-groups" *ngIf="allowEditMode && base.isEditMode()">
          <div class="competence-group" *ngFor="let group of groups">
            <span class="categories-title" *ngIf="group.area">{{ group.area.shortName || group.area.name }}</span>
            <ng-container *ngFor="let row of group.rows; trackBy: trackRow">
              <div
                class="competence-row selectable"
                [class.selected]="isSelected(row.tag.uuid)"
                [style.background]="rowBackground(row, isSelected(row.tag.uuid))"
              >
                <label class="competence-label">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [checked]="isSelected(row.tag.uuid)"
                    (change)="handleCategorySelect($event, row.tag.uuid)"
                  />
                  <span class="competence-number" *ngIf="row.number">{{ row.number }}</span>
                  <span>{{ row.tag.name }}</span>
                </label>
                <button
                  *ngIf="row.help"
                  type="button"
                  class="help-toggle"
                  [attr.aria-expanded]="!collapsedStates[row.tag.uuid]"
                  (click)="toggleCollapse(row.tag.uuid)"
                >
                  <span class="material-symbols-rounded"> info </span>
                </button>
              </div>
              <div [ngbCollapse]="collapsedStates[row.tag.uuid]" *ngIf="row.help">
                <div class="competence-help">{{ row.help }}</div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #legacyLayout>
    <ng-container *ngIf="base.isViewMode()">
      <ng-container *ngIf="selectedCategories$ | async as selectedCategories; else loading">
        <div class="row competences-wrap" *ngIf="selectedCategories.length > 0">
          <div class="col-md-4 col-6 px-2 mb-4" *ngFor="let category of selectedCategories">
            <div class="competence-card">
              <img *ngIf="category.activeIconUrl  && withImages" alt="Competence icon"
                   [src]="getCompetenceImageUrl(category.activeIconUrl)"/>
              {{ category.name }}
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <div class="d-flex flex-column gap-2" *ngIf="allowEditMode && base.isEditMode()">
      <ng-container *ngIf="categories$ | async as categories; else loading">
        <div class="categories-wrapper" *ngFor="let category of categories; let i = index">
          <span class="categories-title">{{category.shortName}}</span>
          <ng-container *ngFor="let competence of category.categories">
            <div
              class="d-flex competence-select-card justify-content-between"
              (click)="toggleCollapse(competence.uuid)"
              type="button"
              [class.opened]="!collapsedStates[competence.uuid]"
            >
              <div class="d-flex align-items-center gap-3">
                <div class="form-check w-auto">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    (click)="$event.stopPropagation()"
                    [checked]="control.value?.includes(competence.uuid)"
                    (change)="handleCategorySelect($event, competence.uuid)"
                  />
                </div>
                <img
                  *ngIf="competence.activeIconUrl"
                  alt="Competence icon"
                  class="competence-image"
                  [src]="getCompetenceImageUrl(competence.activeIconUrl)"
                />
                {{ competence.name }}
              </div>
              <div class="d-flex align-items-center">
                <span *ngIf="competence.description" class="material-symbols-rounded"> keyboard_arrow_down </span>
              </div>
            </div>

            <div [ngbCollapse]="collapsedStates[competence.uuid]" *ngIf="competence.description">
              <div class="px-4 py-3">
                {{ competence.description }}
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <ng-template #loading>
    <div class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </ng-template>

  <div *ngIf="base.mode === base.modeEnum.EDIT" class="actions d-flex justify-content-end mt-4">
    <button (click)="cancel(); base.mode = base.modeEnum.VIEW" class="btn btn-light-outline">
      {{ t('common/cancel') }}
    </button>

    <button (click)="save(); base.setMode(base.modeEnum.VIEW)" class="btn btn-primary">
      {{ t('common/save') }}
    </button>
  </div>
</isophi-app-portfolio-plan-base-item>
